import { render } from "./BaseWidgetTitle.vue?vue&type=template&id=4e407400&scoped=true"
const script = {}

import "./BaseWidgetTitle.vue?vue&type=style&index=0&id=4e407400&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e407400"]])

export default __exports__